import React, { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useMediaQuery } from 'react-responsive';
import cN from 'classnames';
import styles from './styles.module.scss';
import { setTagList, setSwitchListBy } from '@Redux/search/actions';
import { RootState } from '@Redux/search/store';
import { setAllSelected } from '@Redux/search/All/action';
import { setGroupSelected } from '@Redux/search/Group/action';
import { setHotelSelected } from '@Redux/search/Hotel/action';
import { setVocationSelected } from '@Redux/search/Vacation/action';
import { setTicketSelected } from '@Redux/search/Ticket/action';
import { setFlightSelected } from '@Redux/search/Flight/action';
import { Adjust } from '@components/Common/Icons';
import UseDestCount from '@components/SearchPage/Filters/subComponent/useHook/UseDestCount'; //只特別計算城市部分
import DropDowns from './subComponent/DropDowns';
import FlatBtn from './subComponent/FlatBtn';
import SwitchBtn from './subComponent/SwitchBtn';
import { changeSeoParams, getSessionStorageKeyVal } from '@utils/utils';

interface I_sortOption {
    text: string;
    value: number | string;
}
interface DropdownProps {
    options: I_sortOption[];
    label: string;
}

interface I_sorterByProps {
    flatBtn: I_sortOption[];
    dropdowns: DropdownProps[];
}
interface I_switchOption {
    text: string;
    value: string;
}
interface SortersProps {
    onClickFlatBtnM: (value: boolean) => void;
    sortByOptions: I_sorterByProps;
    switchByOptions: I_switchOption[];
    isClearShadow: boolean;
}

const Sorters: React.FC<SortersProps> = ({
    onClickFlatBtnM,
    sortByOptions,
    switchByOptions,
    isClearShadow,
}) => {
    const moduleName = 'sorters';
    const dispatch = useDispatch();
    const { GroupFilterStore, GroupFilterSelected } = useSelector(
        (state: RootState) => state.search.GroupReducer
    );
    const { HotelFilterStore, HotelFilterSelected } = useSelector(
        (state: RootState) => state.search.HotelReducer
    );
    const { TicketFilterStore, TicketFilterSelected } = useSelector(
        (state: RootState) => state.search.TicketReducer
    );
    const { VocationFilterStore, VocationFilterSelected } = useSelector(
        (state: RootState) => state.search.VocationReducer
    );
    const { FlightFilterStore, FlightFilterSelected } = useSelector(
        (state: RootState) => state.search.FlightReducer
    );
    const { AllFilterStore, AllFilterSelected } = useSelector(
        (state: RootState) => state.search.AllReducer
    );
    const { SwitchListBy, TagList } = useSelector((state: RootState) => state.search.reducer);
    const isMobile = useMediaQuery({ query: '(max-width: 980px)' });

    const SwitchBtnProps = {
        defaultSelect: SwitchListBy,
        options: switchByOptions,
        onSwitched: (value: string) => dispatch(setSwitchListBy(value)),
    };

    let selectedStore = AllFilterSelected;
    let dispatchFn = setAllSelected;
    let filterStore = AllFilterStore;
    let cityCount = UseDestCount(AllFilterSelected.selectedDestinationID);
    switch (TagList) {
        case 'grp':
            dispatchFn = setGroupSelected;
            selectedStore = GroupFilterSelected;
            filterStore = GroupFilterStore;
            cityCount = UseDestCount(GroupFilterSelected.selectedDestinationID);
            break;
        case 'htl':
            dispatchFn = setHotelSelected;
            selectedStore = HotelFilterSelected;
            filterStore = HotelFilterStore;
            cityCount = UseDestCount(HotelFilterSelected.selectedDestinationID);
            break;
        case 'vac':
            dispatchFn = setVocationSelected;
            selectedStore = VocationFilterSelected;
            filterStore = VocationFilterStore;
            cityCount = UseDestCount(VocationFilterSelected.selectedDestinationID);
            break;
        case 'etk':
            dispatchFn = setTicketSelected;
            selectedStore = TicketFilterSelected;
            filterStore = TicketFilterStore;
            cityCount = UseDestCount(TicketFilterSelected.selectedDestinationID);
            break;
        case 'flt':
            dispatchFn = setFlightSelected;
            selectedStore = FlightFilterSelected;
            filterStore = FlightFilterStore;
            cityCount = UseDestCount(FlightFilterSelected.selectedDestinationID);
            break;
        default:
            dispatchFn = setAllSelected;
            selectedStore = AllFilterSelected;
            filterStore = AllFilterStore;
            cityCount = UseDestCount(AllFilterSelected.selectedDestinationID);
            break;
    }

    const handlerTagList = (tag: string | number, sortValue: string | number | null) => () => {
        // 各館別切換, number是因為dropdown元件有設定，但此專案只會有string
        // 新需求:網址sort跟taglist參數偵測判斷
        let sort;
        switch (tag) {
            case 'grp':
                switch (sortValue) {
                    case 'b':
                        sort = 1;
                        break;
                    case 'd':
                        sort = 3;
                        break;
                    case 'e':
                        sort = 4;
                        break;
                    case 'f':
                        sort = 8;
                        break;
                    default:
                        sort = '';
                        sortValue = 'a'; //網址參數都不符則給預設
                        break;
                }
                dispatchFn = setGroupSelected;
                break;
            case 'htl':
                switch (sortValue) {
                    case 'b':
                        sort = 1;
                        break;
                    case 'c':
                        sort = 2;
                        break;
                    case 'f':
                        sort = 4;
                        break;
                    case 'g':
                        sort = 6;
                        break;
                    case 'h':
                        sort = 8;
                        break;
                    default:
                        sort = '';
                        sortValue = 'a'; //網址參數都不符則給預設
                        break;
                }
                dispatchFn = setHotelSelected;
                break;
            case 'vac':
                switch (sortValue) {
                    case 'b':
                        sort = 1;
                        break;
                    case 'c':
                        sort = 2;
                        break;
                    case 'f':
                        sort = 4;
                        break;
                    case 'i':
                        sort = 6;
                        break;
                    case 'e':
                        sort = 7;
                        break;
                    default:
                        sort = '';
                        sortValue = 'a'; //網址參數都不符則給預設
                        break;
                }
                dispatchFn = setVocationSelected;
                break;
            case 'etk':
                switch (sortValue) {
                    case 'b':
                        sort = 1;
                        break;
                    case 'c':
                        sort = 2;
                        break;
                    case 'f':
                        sort = 4;
                        break;
                    default:
                        sort = '';
                        sortValue = 'a'; //網址參數都不符則給預設
                        break;
                }
                dispatchFn = setTicketSelected;
                break;
            case 'flt':
                switch (sortValue) {
                    case 'b':
                        sort = '1';
                        break;
                    case 'c':
                        sort = 2;
                        break;
                    case 'f':
                        sort = 4;
                        break;
                    default:
                        sort = '';
                        sortValue = 'a'; //網址參數都不符則給預設
                        break;
                }
                dispatchFn = setFlightSelected;
                break;
            default:
                switch (sortValue) {
                    case 'b':
                        sort = 1;
                        break;
                    case 'c':
                        sort = 2;
                        break;
                    default:
                        sort = '';
                        sortValue = 'a'; //網址參數都不符則給預設
                        break;
                }
                dispatchFn = setAllSelected;
        }
        changeSeoParams(sortValue, tag);
        dispatch(setTagList(tag));
        dispatch(dispatchFn({ SortType: sort }));
    };

    const filteredNum = useMemo(() => {
        //計算用戶點了多少篩選，價格篩選雖是陣列但只能算1種
        let num = 0;
        for (const [key, val] of Object.entries(selectedStore)) {
            if (val instanceof Array) {
                if (key !== 'selectedPrices' && key !== 'selectedDestinationID') {
                    // 排除金額跟目的地計算
                    num += val.length;
                }
                if (key === 'selectedPrices') {
                    num = val.length > 0 ? num + 1 : num;
                }
            }
            if (val instanceof Number) num += 1;
        }
        return num + cityCount;
    }, [selectedStore, cityCount]);

    // 看sessionStorage中是否有keyword參數
    const KEYWORD = window.sessionStorage.getItem('Keyword') || '';

    // 排序的狀態對應館別標籤
    return (
        <div className={cN(moduleName, styles[`${moduleName}`])}>
            <ul
                className={cN(
                    styles.SortersList,
                    styles.TagList,
                    isMobile ? styles.overflowX : '',
                    isClearShadow ? '' : styles.boxShadow_bottom
                )}
            >
                {sortByOptions.flatBtn.map((val) => {
                    const seo_sort = getSessionStorageKeyVal('Sort');
                    const FlatBtnProps = {
                        text: val.text,
                        value: val.value,
                        onClicked: handlerTagList(val.value, seo_sort),
                    };

                    return (
                        <li
                            className={cN(styles.SortersItem, {
                                active: TagList == FlatBtnProps.value,
                            })}
                            key={val.text}
                        >
                            <FlatBtn {...FlatBtnProps} />
                        </li>
                    );
                })}
            </ul>
            <ul
                className={cN(
                    styles.SortersList,
                    styles.Sorters,
                    isMobile ? styles.SortersListM : ''
                )}
            >
                {/* M版篩選條件slidePage */}
                {isMobile ? (
                    KEYWORD &&
                    (filterStore.PriceMax !== 1 || filterStore.DestinationList.length !== 0) ? (
                        <li
                            className={cN(styles.SortersItem, styles.boxShadow)}
                            onClick={() => onClickFlatBtnM(true)}
                            style={{ color: filteredNum > 0 ? '#f03742' : '#222' }}
                        >
                            <div className={styles.SortersItem_filterIcon}>
                                <Adjust />
                            </div>
                            <div>篩選條件({filteredNum})</div>
                        </li>
                    ) : null
                ) : (
                    <li className={styles.mr_10}>排序</li>
                )}
                {/* 館別各自的排序 */}
                {sortByOptions.dropdowns.map((item: DropdownProps, idx: number) => {
                    if (item.label !== TagList) return;
                    const dropDownsProps = {
                        defaultSelect: selectedStore.SortType,
                        options: item.options,
                        onSelect: (value: number) => {
                            dispatch(dispatchFn({ SortType: value, Page: 1, PageSize: 10 }));
                            item.options.forEach((obj: any) => {
                                // 排序seo 轉換params
                                if (obj.value === value) changeSeoParams(obj.seo_params, TagList);
                            });
                        },
                    };

                    return (
                        <li
                            key={`${idx}}`}
                            className={cN(
                                styles.SortersItem,
                                styles.boxShadow,
                                !isMobile && styles.mr_10
                            )}
                        >
                            <DropDowns {...dropDownsProps} />
                        </li>
                    );
                })}
                <li className={cN(styles.SortersItem)}>
                    <SwitchBtn {...SwitchBtnProps} />
                </li>
            </ul>
        </div>
    );
};

export default Sorters;
